import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import * as Utils from "../../inc/Utils";
import DatePicker from "react-datepicker";
import Select from 'react-select' 
import moment from "moment-timezone";

export default function LeadFormProjectCreate() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [agency, setAgency] = React.useState('');
    let [lang, setLanguage] = React.useState('');
    let [projectType, setProjectType] = React.useState('');
    let [projectCode, setProjectCode] = React.useState('');
    let [project, setProject] = React.useState('');
    let [createDate, setCreateDate] = React.useState('');  
    let [freeForm, setFreeForm] = React.useState('');

    let [agencyId, setAgencyId] = React.useState(null);
    let [langId, setLanguageId] = React.useState(null);
    let [projectTypeId, setProjectTypeId] = React.useState(null);
    let [projectCodeId, setProjectCodeId] = React.useState(null);
    let [projectCodeSelectedId, setProjectCodeSelectedId] = React.useState(null);
    let [projectName, setProjectName] = React.useState(null);

    let [projectPlaceholder, setProjectPlaceholder] = React.useState('...');
    let [projectCodePlaceholder, setProjectCodePlaceholder] = React.useState('...');
    let [disableProjectCode, setDisableProjectCode] = React.useState(true);
    let [preview, setPreview] = React.useState('');

    const navigate = useNavigate();

    React.useEffect(() => {
        (async function() {
            try {
                const resLanguage = await Utils.getLanguage();
                setLanguage(resLanguage);

                const resProjectType = await Utils.getProjectType();
                setProjectType(resProjectType);

                const resAgency = await Utils.getAgencySlug({agencyId: roles.permissionId === Utils.SUPER_ADMIN_ID ? null : roles.agencyId});
                setAgency(resAgency);
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const onCreate = async () => {

        let param = await getParams();

        if(!langId) {
            toast.error("กรุณาระบุ Language");
        }
        else if(!projectTypeId) {
            toast.error("กรุณาระบุ Project Type");
        }
        else if(!projectCodeId) {
            toast.error("กรุณาระบุ Project Code");
        }
        else if(!agencyId) {
            toast.error("กรุณาระบุ Agency");
        }
        else if(!projectName) {
            toast.error("กรุณาระบุ Project Name");
        }
        else if(!createDate) {
            toast.error("กรุณาระบุ Create Date");
        }
        else if(freeForm && freeForm.includes(' ')) {
            toast.error("Free Form ห้ามมีช่องว่าง");
        }
        else if(freeForm && freeForm.includes('_')) {
            toast.error("Free Form ห้ามมี _");
        }
        else if(param.length <=0 || param.length >= 300) {
            toast.error("ขนาดตัวอักษรต้องไม่เกิน 300");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            const body = {
                                lang: langId ? langId.id : null,
                                projectTypeId: projectTypeId ? projectTypeId.id : null,
                                projectCode: projectCodeId ? projectCodeId : null,
                                projectName: projectName ? projectName : null,
                                createDate: createDate ? new Date(createDate) : null,
                                agencyId: agencyId ? agencyId.slug : null,
                                freeForm: freeForm ? freeForm : null,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                            };

                            fetch(Config.url.API_URL +'/api/leadFormProject/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/leadFormProject', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeLanguageId = async (obj) => {
        setLanguageId(obj);
        setProjectCode('');
        setProjectCodeId(null);
        setProject('');
        setProjectName(null);
        setProjectPlaceholder('...');
        setProjectCodePlaceholder('...');
        setDisableProjectCode(true);

        if(obj && obj.id && projectTypeId) {
            await projectCodeChange(obj.id, projectTypeId.id);
        }
    };
    const onChangeProjectTypeId = async (obj) => {
        setProjectTypeId(obj);
        setProjectCode('');
        setProjectCodeId(null);
        setProject('');
        setProjectName(null);
        setProjectPlaceholder('...');
        setProjectCodePlaceholder('...');
        setDisableProjectCode(true);
        setProjectCodeId(null);
        setProjectCodeSelectedId(null);
        setProjectCode(null);

        if(obj && obj.id && langId) {
            await projectCodeChange(langId.id, obj.id);
        }
    };

    const projectCodeChange = async (langId, projectTypeId, resView = '') => {

        setProjectCodePlaceholder('กำลังโหลด...');

        let resProjectCodeArr = [];

        const resProjectCode = await Utils.getProjectCode(langId, projectTypeId);
        if(resProjectCode && resProjectCode.data) {
            for(let rs of resProjectCode.data) {
                resProjectCodeArr.push({
                    project_code: rs.project_code,
                    project_slug: rs.project_slug,
                    project_title: rs.project_title,
                    project_type_slug : rs.project_type_slug,
                    project_url : rs.project_url
                });
            }

            setProjectCodePlaceholder('Select...');
            setDisableProjectCode(false);
        }
        else {
            setProjectCode(null);
            setProjectCodePlaceholder('ไม่พบข้อมูล..');
        }
        setProjectCode(resProjectCodeArr);
    };

    const onChangeProjectCodeId = async (obj) => {
        setProjectCodeSelectedId(obj);
        setProjectCodeId(obj.project_code);
        setProject('');
        setProjectName(null);
        setProjectPlaceholder('...');
        if(obj && obj.project_code) {
            setProjectName(obj.project_slug);
        }
    };
    const onChangeAgencyId = (obj) => {
        setAgencyId(obj);
    };
    const onChangeCreateDate = async (value) => {
        setCreateDate(value);
    };
    const onPreviewUTM = async () => {
        const param = await getParams();
        setPreview(param);
    };

    async function getParams() {
        // Format : {"{Project ID}_{Agency}_{Project Slug}_{Create Date}_{Free Form}_[ST]"}
        // ตัวอย่าง : 70092_MS_Apitownudonthani1_30Sep2023_Apdata_[ST]

        let date = new Date(createDate);
        let newCreateDate = date.getDate() + '' + Utils.monthNames[date.getMonth()] + '' + date.getFullYear();

        let param = projectCodeId + '_' + agencyId.slug + '_' + projectName + '_' + newCreateDate;
        if(freeForm) {
            param += '_' + Utils.removeSpaceUnderScore(freeForm);
        }
        param += '_[ST]';

        return param;
    }

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Lead Form Project</div>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="d-block mb-1 small">{"{Project ID}_{Agency}_{Project Slug}_{Create Date}_{Free Form}_[ST]"}</div>
                        <form>
                            <div className="row g-3 border rounded bg-light p-2 mt-0 mb-3">
                                <div className="col-12 mt-1">
                                    <label htmlFor="langId" className="form-label">Language <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={lang}
                                        onChange={(event) => onChangeLanguageId(event)}
                                        value={langId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="projectTypeId" className="form-label">Project Type <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={projectType}
                                        onChange={(event) => onChangeProjectTypeId(event)}
                                        value={projectTypeId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="projectName" className="form-label">Project Code<span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        isDisabled={disableProjectCode}
                                        classNamePrefix="form-select-search"
                                        placeholder={projectCodePlaceholder}
                                        options={projectCode}
                                        onChange={(event) => onChangeProjectCodeId(event)}
                                        value={projectCodeSelectedId}
                                        getOptionValue={(option) => `${option.project_code}`}
                                        getOptionLabel={(option) => `${option.project_code} : ${option.project_title}`}
                                    />
                                </div>
                            </div>
                            <div className="row g-3 border rounded bg-light p-2 my-3">
                                <div className="col-12 mt-1">
                                    <label htmlFor="agency" className="form-label">Agency <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={agency}
                                        onChange={(event) => onChangeAgencyId(event)}
                                        value={agencyId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.slug}`}
                                    />
                                </div>
                            </div>
                            <div className="row g-3 border rounded bg-light p-2 my-3">
                                <div className="col-12 mt-1">
                                    <label htmlFor="createDate" className="form-label">Create Date <span className="text-danger">*</span></label>
                                    <DatePicker
                                        selected={createDate}
                                        onChange={(date) => onChangeCreateDate(date)}
                                        dateFormat="yyyy-MM-dd"
                                        wrapperClassName="w-100"
                                        className="form-control" />
                                </div>
                            </div>

                            <div className="row g-3 border rounded bg-yellow-light p-2 my-3">
                                <div className="col-12 mt-1">
                                    <label htmlFor="createDate" className="form-label">Free Form</label>
                                    <div className="css-b62m3t-container"><input className="form-control" type="text" id="freeForm" name="freeForm" onKeyUp={e => {
                                        if(e && e.target.value) {
                                            setFreeForm(e.target.value);
                                        }
                                        else {
                                            setFreeForm('');
                                        }
                                    }} onBlur={e => {
                                        setFreeForm(e.target.value ? Utils.removeSpaceUnderScore(e.target.value) : '');
                                        document.getElementById("freeForm").value = e.target.value ? Utils.removeSpaceUnderScore(e.target.value) : '';
                                    }} /></div>
                                </div>
                            </div>

                            <div className="row g-3 border rounded bg-green-light p-2 my-3">
                                <div className="col-12 mt-0">
                                    <label htmlFor="preview" className="form-label"><button type="button" className="btn btn-sm btn-light" onClick={onPreviewUTM} disabled={!agencyId}>Preview</button></label>
                                    <div className="noselect-url w100 rounded">{preview}</div>
                                    <p className="mt-2 mb-0">ตัวอักษร : {preview.length}</p>
                                </div>
                            </div>

                            <div className="row g-3">
                                <div className="col-12">
                                    <button type="button" className="btn btn-primary" onClick={onCreate}><span
                                        className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                    <NavLink className="btn btn-sm btn-light ms-2" to='/leadFormProject'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                    <Toaster position="bottom-right" />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
}